import PropTypes from "prop-types";
import styles from "./index.css";
import classNames from "classnames";
import { DateTime } from "luxon";
import { withTranslation } from "../../translation";
import getCopyKeys from "./getCopyKeys";
import CategoryHeaderRibbon from "../../CategoryHeaderRibbon";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../../state/modules/layout/constants";

const CategoryHeaderCopy = ({
  header,
  isComingSoon,
  endDate,
  formatTranslation,
  viewportCategory
}) => {
  const copyKeys = getCopyKeys(isComingSoon);
  const headerClassesMap = {
    [LARGE_VIEWPORT]: "asosWorld1",
    [MEDIUM_VIEWPORT]: "asosWorld1",
    [SMALL_VIEWPORT]: "asosWorld3"
  };
  const headerClass = classNames(
    styles.header,
    headerClassesMap[viewportCategory]
  );

  return (
    <div className={styles.copy}>
      <div className={styles.constrained}>
        <div className={styles.content}>
          <div className={styles.leftSpacer}></div>
          <div>
            <p>
              <span className={headerClass}>{header}</span>
            </p>
            <p className={styles.mobileMidSpacer}></p>
            <p className={styles.midSpacer}></p>
            <p>
              <span className={classNames("london2", styles.eapLabel)}>
                {formatTranslation(copyKeys.intro)}
              </span>
            </p>
            <p>
              <span className={classNames("london2", styles.eapLabel)}>
                {DateTime.fromISO(endDate).toFormat("ccc dd MMM")}
              </span>
            </p>
            <p>
              <span className={classNames("leavesden2", styles.description)}>
                {formatTranslation(copyKeys.description)}
              </span>
            </p>
          </div>
        </div>
      </div>
      <CategoryHeaderRibbon
        ribbonText={formatTranslation(copyKeys.ribbon)}
        {...(isComingSoon ? { className: styles.ribbonComingSoon } : {})}
      />
    </div>
  );
};

CategoryHeaderCopy.propTypes = {
  header: PropTypes.string.isRequired,
  isComingSoon: PropTypes.bool,
  endDate: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default withTranslation(CategoryHeaderCopy);
